export const EMAIL_REGEX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#^+=$!%*?&])[A-Za-z\d@#^+=$!%*?&]{8,}$/;
export const PHONE_FULL_NUMBER_COUNT = 17;
